module.exports = __webpack_public_path__ + "static/media/MentorJohn.15380d68.jpg";